// Strip field: preferred date pill with inline calendar popup.
// Not mounted in BookingStripPanel by default (location-only strip); kept
// for reuse if the three-field strip layout returns.

import styles from '../styles/widget.module.css';
import { formatPillDate } from '../utils/datetime';
import type { BookingAction, BookingState } from '../state/machine';
import { useClickOutside } from '../hooks/useClickOutside';
import { useOpenClose } from '../hooks/useOpenClose';
import CalendarIcon from '../assets/icons/Calendar';
import { Calendar } from '../steps/Calendar';
import { useAvailableDates } from '../hooks/useAvailableDates';

interface DateFieldStripProps {
  state: BookingState;
  dispatch: React.Dispatch<BookingAction>;
  disabled?: boolean
}

export function DateFieldStrip({ state, dispatch, disabled = false }: DateFieldStripProps) {
  const { isOpen, setIsOpen, toggle } = useOpenClose()
  const wrapperRef = useClickOutside<HTMLDivElement>(() => {
    setIsOpen(false);
  }, { enabled: isOpen });
  const { availableDates, loading } = useAvailableDates(
    state.selectedLocation,
    state.selectedFittingType,
    state.selectedFitterId,
  );


  if (state.selectedDate) {
    return (
      <div className={styles.stripPill}>
        <span className={styles.label}>Date</span>
        <div className={styles.stripPillValue}>
          <span>{formatPillDate(state.selectedDate)}</span>
          <button
            className={styles.stripPillChange}
            onClick={() => dispatch({ type: 'SELECT_DATE', payload: null })}
          >
            Change
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.field} ${disabled ? styles.panelSectionDisabled : ''}`} ref={wrapperRef}>
      <div className={`${styles.stripPill} ${styles.clickable}`} onClick={toggle}>
        <span className={styles.label}>Date</span>
        <div className={styles.stripPillValue}>
          <span className={styles.stringPillLabel}>Select Preferred Date</span>
          {isOpen ? <button
            className={styles.stripPillChange}
            onClick={() => setIsOpen(false)}
          >
            Close
          </button> : <CalendarIcon />}
        </div>
      </div>
      {isOpen && <Calendar
        selectedDate={state.selectedDate}
        onChange={(d) => dispatch({ type: 'SELECT_DATE', payload: d })}
        locationName={state.selectedLocation?.name}
        availableDates={availableDates}
        loading={loading}
        className={styles.displayAbsolute}
      />}
    </div>
  );
}
